var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    stroke: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9667 33.0494C24.7623 33.0494 24.5635 32.9831 24.4 32.8605L20.6226 30.0274C20.5053 29.9394 20.4101 29.8254 20.3446 29.6943C20.279 29.5631 20.2449 29.4185 20.2449 29.2719V23.9646L13.6192 16.5108C13.1487 15.98 12.8415 15.3245 12.7345 14.6233C12.6275 13.922 12.7253 13.2048 13.0161 12.5577C13.3069 11.9107 13.7785 11.3615 14.374 10.976C14.9695 10.5905 15.6636 10.3852 16.373 10.3848H29.7829C30.4922 10.3856 31.1862 10.5912 31.7814 10.977C32.3767 11.3627 32.8479 11.9121 33.1384 12.5592C33.429 13.2063 33.5265 13.9235 33.4192 14.6247C33.3119 15.3259 33.0045 15.9811 32.5338 16.5118L25.911 23.9646V32.105C25.911 32.3555 25.8115 32.5957 25.6344 32.7728C25.4573 32.9499 25.2171 33.0494 24.9667 33.0494ZM22.1336 28.7997L24.0223 30.2163V23.6058C24.0225 23.3746 24.1075 23.1514 24.2612 22.9787L31.1248 15.2567C31.3537 14.998 31.503 14.6788 31.5549 14.3373C31.6068 13.9959 31.559 13.6467 31.4173 13.3317C31.2757 13.0167 31.0461 12.7493 30.7561 12.5616C30.4662 12.3739 30.1283 12.2738 29.7829 12.2735H16.373C16.0278 12.274 15.6901 12.3741 15.4003 12.5618C15.1106 12.7494 14.8811 13.0167 14.7395 13.3315C14.5978 13.6463 14.55 13.9953 14.6017 14.3366C14.6534 14.6779 14.8025 14.9971 15.0311 15.2558L21.8956 22.9787C22.049 23.1516 22.1336 23.3747 22.1336 23.6058V28.7997Z",
    fill: "#020066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.0038b7ad79ab5160f3e8e7c18bb341c3.svg";
export { ForwardRef as ReactComponent };